import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-form';
import { Input } from '../Form';
import {
    createReactFormValidator,
    required,
    requiredEmail,
} from '../../utils/validation';

// eslint-disable-next-line
import styles from './signin.scss';

class SignInForm extends PureComponent {
    render() {
        const { onSubmit, submitting, error, email, 'data-testid': dataTestId } = this.props;

        const defaultValues = {
            email: email || '',
        };

        return (
            <div>
                <Form
                    onSubmit={(values) => onSubmit(values)}
                    defaultValues={defaultValues}
                >
                    {(formApi) => {
                        const { submitForm } = formApi;
                        const handleFormSubmit = (event) => {
                            event.preventDefault();
                            submitForm();
                        };
                        // exposeFormApi(formApi);
                        return (
                            <form onSubmit={handleFormSubmit} data-testid={dataTestId && `${dataTestId}.form`}>
                                <Input
                                    id={`emailInput`}
                                    field={`email`}
                                    label="Email"
                                    validate={createReactFormValidator(requiredEmail)}
                                    hiddenLabel={true}
                                    disableProfanityCheck={true}
                                    themeV3
                                    data-testid={dataTestId && `${dataTestId}.email-input`}
                                />
                                <Input
                                    id="passwordInput"
                                    field="password"
                                    type="password"
                                    validate={createReactFormValidator(required)}
                                    label={`Password`}
                                    hiddenLabel={true}
                                    disableProfanityCheck={true}
                                    themeV3
                                    data-testid={dataTestId && `${dataTestId}.password-input`}
                                />

                                {error && (
                                    <div
                                        className="invalid-feedback"
                                        dangerouslySetInnerHTML={{ __html: error }}
                                        data-testid={dataTestId && `${dataTestId}.error`}
                                    />
                                )}

                                <div>
                                    <button
                                        type="submit"
                                        className={`btn btn-primary btn-xl btn-block fw600`}
                                        disabled={submitting}
                                        data-testid={dataTestId && `${dataTestId}.submit-btn`}
                                    >
                                        SIGN IN
                                    </button>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        );
    }
}

SignInForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
    email: PropTypes.string,
    'data-testid': PropTypes.string,
};

SignInForm.defaultProps = {
    submitting: false,
    error: null,
    email: '',
    'data-testid': undefined,
};

export default SignInForm;
